import styled from 'styled-components';
import WithDirection from '@iso/lib/helpers/rtl';

const IncidentPage = styled.div`
  width: 100%;
  height: 100%;

  .btn-success {
    background-color: #0B2A1B !important;
    border-color: #0B2A1B;
    height: 40px;
    border-radius: 8px;
    &:hover {
      opacity: 0.8;
    }
  }

  .search-bar {
    background: rgba(143, 146, 161, 0.05);
    border-radius: 12px;
    border: none;
    height: 40px;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    flex-direction: row-reverse;
    max-width: 228px;
  }

  .search-bar .ant-input {
    background: none !important;
    border: none !important;
    color: #8F92A1;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
  }

  .site-form-item-icon {
    height: 19px;
    width: 19px;
    color: #8F92A1;
    font-size: 19px;
  }

  .site-form-item-cancel {
    height: 15px;
    width: 15px;
    color: #8F92A1;
    font-size: 15px;
  }

  .incident-search-input {
    border-radius: 8px;
    &.ant-input-affix-wrapper-focused, &:hover {
      box-shadow: none;
      border-color: #0B2A1B;
    }

    input {
      border: none !important;
      border-radius: 0 !important;
      &:hover, &:focus {
        box-shadow: none;
      }
    }
  }

  .incident-refresh-button {
    &:hover {
      border-color: #0B2A1B;
      color: #0B2A1B;
    }
  }

  .manage-property-header {
    padding: 20px 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: auto;
  }

  .holiday-card {
    border-radius: 8px;

    .ant-card-head {
      background: #fafafa;
      border-bottom: 1px solid #f0f0f0;
    }
  }

  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    flex-wrap: wrap;
    gap: 12px;
  }

  .card-title {
    font-size: 16px;
    font-weight: 600;
    color: #101828;
  }

  .card-actions {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
  }

  .stat-card {
    border-radius: 8px;
    transition: all 0.3s;
    &:hover {
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
      transform: translateY(-2px);
    }
  }

  .filters-wrapper {
    background: rgba(143, 146, 161, 0.05);
    border-radius: 12px;
    padding: 16px;
    margin-bottom: 16px;
  }

  .ant-card {
    border-radius: 8px;
  }

  .ant-statistic-title {
    font-size: 14px;
    color: #667085;
  }

  .ant-statistic-content {
    font-size: 24px;
    font-weight: 600;
  }

  .ant-spin-dot-item {
    background-color: #0B2A1B !important;
  }

  .ant-select-selector {
    border-radius: 8px !important;
  }

  .ant-input {
    border-radius: 8px;
  }

  .ant-btn {
    border-radius: 8px;
  }

  .ant-tag {
    border-radius: 4px;
  }

  .incident-table {
    a {
      color: rgba(0, 0, 0, 0.85);
    }
  }

  .incident-type-option {
    display: flex;
    flex-direction: column;
    line-height: 1.3;
  }

  .incident-type-label {
    font-weight: 500;
    color: #101828;
  }

  .incident-type-description {
    font-size: 12px;
    color: #667085;
  }

  @media only screen and (max-width: 1200px) {
    .card-header {
      flex-direction: column;
      align-items: flex-start;
    }

    .card-actions {
      width: 100%;
      justify-content: flex-start;
    }
  }

  @media only screen and (max-width: 768px) {
    .manage-property-header {
      flex-direction: column;
      align-items: flex-start;
      gap: 16px;
    }

    .search-bar {
      max-width: 100%;
      width: 100%;
    }

    .card-actions {
      flex-direction: column;
      align-items: stretch;

      .ant-input,
      .ant-select,
      .ant-btn {
        width: 100% !important;
        min-width: 100% !important;
      }
    }
  }
`;

export default WithDirection(IncidentPage);
